
import React from 'react';
import { Sparkles, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UpdateSuccessModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

const UpdateSuccessModal: React.FC<UpdateSuccessModalProps> = ({ isOpen, onConfirm }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 w-screen h-screen z-[10000] flex items-center justify-center p-6 bg-slate-950/80 backdrop-blur-md animate-in fade-in duration-300">
      <div className="bg-surface p-8 md:p-12 rounded-[28px] border border-black/[0.06] dark:border-white/[0.06] w-full max-w-md animate-in zoom-in-95 duration-200 text-center space-y-8">
        <div className="w-24 h-24 bg-ok/10 rounded-[2.2rem] mx-auto flex items-center justify-center text-ok">
          <Sparkles size={48} className="animate-pulse" />
        </div>
        
        <div className="space-y-3">
          <h3 className="text-2xl font-medium dark:text-ink tracking-[-0.03em]">{t('settings.updateSuccess.title', 'Atualização Concluída')}</h3>
          <p className="text-sm text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
            {t('settings.updateSuccess.desc', 'Agora você pode estudar com a versão mais atualizada do aplicativo. Aproveite!')}
          </p>
        </div>

        <button
          onClick={onConfirm}
          className="text-[13px] font-medium w-full h-12 bg-ok text-surface rounded-full hover:opacity-90 active:scale-95 transition-all flex items-center justify-center gap-3 group"
        >
          <Check size={18} className="group-hover:scale-125 transition-transform" />
          {t('settings.updateSuccess.confirm', 'Confirmar')}
        </button>
      </div>
    </div>
  );
};

export default UpdateSuccessModal;
